// 生产环境用
const Wave2TimeLineProd: any = {
    us: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2024/04/24 15:00:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
        // detail: '2023/06/16 15:00:00 GMT+8',
    },
    ca: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2024/04/24 15:00:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
        // detail: '2023/06/16 15:00:00 GMT+8',
    },
    // 0616 欧洲六站 夏季促销 @陈琨
    de: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    fr: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    it: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    es: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    eu: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    uk: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/07/24 15:00 GMT+8',
        // crowdfunding: '2023/05/15 21:00:00 GMT+8',
    },
    jp: {
        crowdfunding: '2023/04/26 10:00:00 GMT+8',
        crowdfunding_stage2: '2023/05/09 23:00:00 GMT+8',
        detail: '2023/05/22 23:00:00 GMT+8', // 0515版本要求改为22号 @陈琨
    },
    cn: {
        detail: '2023/04/26 10:00:00 GMT+8',
    },
    kr: {
        detail: '2023/05/10 11:00:00 GMT+8',
    },
    // 2023/07/03 预热 + 详情
    au: {
        teaser: '2023/07/03 10:00:00 GMT+8',
        detail: '2023/07/18 10:00:00 GMT+8',
    },
    sa: {
        teaser: '2023/07/03 10:00:00 GMT+8',
        detail: '2023/07/18 10:00:00 GMT+8',
    },
};

const Wave2TimeLineTest: any = {
    us: {
        teaser: '2023/03/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/15 21:00:00 GMT+8',
        // detail: '2023/06/16 15:00:00 GMT+8',
    },
    ca: {
        teaser: '2023/03/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/15 21:00:00 GMT+8',
        // detail: '2023/06/16 15:00:00 GMT+8',
    },
    de: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    fr: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    it: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    es: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    eu: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    uk: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
        // crowdfunding: '2023/04/15 21:00:00 GMT+8',
    },
    jp: {
        crowdfunding: '2023/04/26 10:00:00 GMT+8',
        crowdfunding_stage2: '2023/05/06 23:00:00 GMT+8',
        detail: '2023/05/17 23:00:00 GMT+8',
    },
    cn: {
        detail: '2023/04/26 10:00:00 GMT+8',
    },
    kr: {
        detail: '2023/04/10 11:00:00 GMT+8',
    },
    // 2023/07/03 预热 + 详情
    au: {
        teaser: '2023/06/03 10:00:00 GMT+8',
        detail: '2023/06/18 10:00:00 GMT+8',
    },
    sa: {
        teaser: '2023/07/03 10:00:00 GMT+8',
        detail: '2023/07/18 10:00:00 GMT+8',
    },
};

export const getWave2Timeline = (locale: string, flag?: boolean) => {
    return flag ? Wave2TimeLineTest[locale] || Wave2TimeLineTest.us : Wave2TimeLineProd[locale] || Wave2TimeLineProd.us;
};

export const enum STAGES {
    TEASER,
    CRODWFUNDING,
    DETAIL,
    UNKNOWN,
}

export const ACTIVITY_MAP: any = {
    jp: 18,
    us: 19,
    ca: 20,
    uk: 24,
    fr: 27,
    de: 30,
    eu: 33,
    es: 36,
    it: 39,
    ph: 56,
};

export const getVideoSource = (locale: string) => {
    switch (locale) {
        case 'us':
            return ['/video/wave2/h5/cool-hot/section_e_2_f.webm', '/video/wave2/h5/cool-hot/section_e_2_f.mp4'];
        default:
            return ['/video/wave2/h5/cool-hot/section_e_2_c.webm', '/video/wave2/h5/cool-hot/section_e_2_c.mp4'];
    }
};

export const getTCWave2 = (locale: string) => {
    const map: any = {
        jp: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_wave2',
            links: [
                'https://jp.ecoflow.com/pages/price-guarantee',
                'mailto:hello.jp@ecoflow.com',
                'mailto:support.jp@ecoflow.com',
                'https://jp.ecoflow.com/pages/warranty-policy',
                'https://jp.ecoflow.com/pages/online-store-policy',
            ],
        },
        us: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_wave2',
            links: ['https://www.ecoflow.com/us', 'mailto:support@ecoflow.com'],
        },
        ca: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_wave2',
            links: ['https://www.ecoflow.com/us', 'mailto:support@ecoflow.com'],
        },
    };
    return map[locale] || map.us;
};
